
import BScroll from "better-scroll";
import MyCard from "@/components/Card";
import LoadMore from 'vux/src/components/load-more/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
data() {
return {
bscroll: "",
bookdata: [],
loadTip: "",
isLoading: false,
reBorrow: this.$route.query.type == 1 ? true : false 
};
},
components: {
MyCard,
LoadMore,
XButton
},
mounted() {
this.initScroll();
this.loadBooks();
if (this.reBorrow) {
document.title = "图书续借";
}
},
methods: {
initScroll() {
let wrapper = document.querySelector(".p-borrow");
if (!this.bscroll) {
this.bscroll = new BScroll(wrapper, {
click: true,
bounce: {
top: false,
bottom: false,
left: false,
right: false
}
});
}
},
jumpBookDetail(params, bookdata) {
try {
sessionStorage.setItem("bookInfo", JSON.stringify(bookdata));
} catch (error) {

}
this.$router.push({
path: "/bookDetail",
query: {
isbn: params.isbn,
marcid: params.marcid
}
});
},
loadBooks() {
this.isLoading = true;
this.loadTip = "加载中";
this.$http("post", "/book/currentBorrow")
.then(res => {
this.isLoading = false;
if (res.data.length === 0) {
this.loadTip = "暂无数据";
} else {
this.loadTip = "";
}
res.data.forEach(book => {
let bookData = {
isbn: book["bookisbn"],
marcid: book["marcid"],
bookBarCode: book["条形码"],
bookName: book["题名"],
infos: [
{
name: "流通状态",
value: book["流通状态"]
},
{
name: "条形码",
value: book["条形码"]
},
{
name: "借阅状态",
value: book["借阅状态"]
},
{
name: "借出日期",
value: book["借出日期"]
},
{
name: "应还日期",
value: book["应还日期"]
}
]
};
this.bookdata.push(bookData);
});
})
.catch(() => {
this.isLoading = false;
this.loadTip = "";
});
},
handleReBorrow(bookBarCode) {
this.$vux.loading.show();
this.$http("post", "/book/rennew", {
bookBarCode
})
.then(res => {
this.$vux.loading.hide();
this.$vux.toast.text(res.message);

this.bookdata = [];
this.loadBooks();
})
.catch(() => {
this.$vux.loading.hide();
});
}
}
};
